import React from "react" ;
import { IonGrid, IonRow, IonCol, IonToggle  } from '@ionic/react';

const SummaryComponent = () => {

    return (
        <>
            <div className='summary'>
              <IonGrid>
                <IonRow>
                <IonCol size="7">
                  <h5>Pickup Location</h5>
                   <h4>Cle Start Location </h4>
                   <ion-item lines="none">
                    <ion-label>Optimise Route</ion-label>
                    <IonToggle slot="end" name="blueberry" mode="ios" checked={false}></IonToggle>
                  </ion-item>
                </IonCol>
                <IonCol size="5">
                  <h5>Total Fare</h5>
                   <h1>S$ 25</h1>
                   <p>Inclusive of GST <br/><b>Learn more</b> about our delivery charges</p>
                </IonCol>
                </IonRow>
              </IonGrid>
              
            </div>
        </>
    )
}

export default SummaryComponent;